import { createAction, props } from '@ngrx/store';
import { ITokenDados } from '@shared/utils/interfaces/token.interface';

export const salvarDadosToken = createAction('[Token] Salvar dados do token', props<{ dadosToken: ITokenDados }>());
